module.exports = __webpack_public_path__ + "static/media/Paratiisi-BG-Image-200x100.30d4df1c.png";